import "./Container_module.css";
const Container_module_rslib_entry_ = {
    container: "container-QNhgaH"
};
export { Container_module_rslib_entry_ as default };

//# sourceMappingURL=Container.module.js.map